import styled from "styled-components";
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useState } from "react";
import { TextInputWTitle } from "../Inputs/TextInputWTitle";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { SelectInputWTitle } from "../Inputs/SelectInputWTitle";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { AddRounded, ContentCopyRounded, ContentPasteGoRounded } from "@mui/icons-material";
import { Loading } from "../Loading";
import { PostDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { useSnackbar } from "notistack";
import { Messages } from "../../Data/Messages";
import { CurrenciesSelector } from "../Inputs/CurrenciesSelector";
import { TextInputBig } from "../Inputs/TextInputBig";
import { TransportTypeV2Selector } from "../Inputs/TransportTypeV2Selector";
import { CountriesSelector } from "../Inputs/CountriesSelector";
import { CitiesSelector } from "../Inputs/CitiesSelector";
import { ServiceTypeV2Selector } from "../Inputs/ServiceTypeV2Selector";
import { DictioneryPanel } from "../../Data/DictioneryPanel";
import { TextBtn2 } from "../Inputs/TextBtn2";

const Style = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    .row {
        align-items: center;
        display: flex;
        gap: 0.7rem;
    }
`;
export default function FormTags(props){
    const {lang = "fa"} = props;
    const { enqueueSnackbar } = useSnackbar();

    const [dialogLoading, setDialogLoading] = useState(false);
    const [dialogError, setDialogError] = useState({});
    const [data, setData] = useState((props.dialogData) ? props.dialogData : {});
    const onChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        let temp = {...data};
        temp[name] = value;
        setData(temp);
    }
    const onChangeBool = (e) => {
        const name = e.target.name;
        let temp = {...data};
        temp[name] = !((temp[name]) ? true : false);
        setData(temp);
    }
    const onChangeNum = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let temp = {...data};
        temp[name] = "";
        if(isNaN(parseInt(value)) === false){
            temp[name] = parseInt(value);
        }
        setData(temp);
    }
    const sendUpdate = async (e) => {
        let formdata = new FormData();
        let keys = Object.keys(data);
        let errors = {};
        if(keys.findIndex(v => v === "Tag_Id") !== -1){
            formdata.append("Tag_Id", data.Tag_Id);
        }
        
        let keylistRequierd = [
            "Tag_Name",
            "Tag_EnName",
        ]
        for (let i = 0; i < keylistRequierd.length; i++) {
            const element = keylistRequierd[i];
            if(keys.findIndex(v => v === element) !== -1){
                formdata.append(element, data[element]);
            } else {
                errors[element] = "پر شود"
            }
        }

        if(Object.keys(errors).length){
            setDialogError(errors)
            return;
        }
        setDialogLoading(true);
        setDialogError({})
        let response;
        if(data.Tag_Id > 0){
            // update
            response = await PostDataPromise(props.apiBase + "/update", formdata);
        } else {
            // new
            response = await PostDataPromise(props.apiBase + "/insert", formdata);
        }
        setDialogLoading(false);
        let parsed = JSON.parse(response);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            // okay
            enqueueSnackbar(Messages.success, { variant: "success" });
            props.save()
        } else {
            if(parsed.data && typeof parsed.data.message === "string"){
                enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
            }
            setDialogError((parsed.data) ? parsed.data.message : {})
        }
    }
    return(
        <>
            <DialogContent dividers sx={{display: "flex", flexDirection: "column"}}>
                <Style>
                    <input type="hidden" name="id" value={data.Tag_Id}/>
                    
                    <TextInputWTitle
                        title={DictioneryPanel.packagesDict.planName[lang]}
                        name={"Tag_Name"}
                        value={data.Tag_Name}
                        onchange={onChange}
                        error={(dialogError.Tag_Name) ? dialogError.Tag_Name : ""}
                    />
                    <TextInputWTitle
                        title={DictioneryPanel.packagesDict.planNameEn[lang]}
                        name={"Tag_EnName"}
                        value={data.Tag_EnName}
                        onchange={onChange}
                        error={(dialogError.Tag_EnName) ? dialogError.Tag_EnName : ""}
                    />
                </Style>
            </DialogContent>
            <DialogActions sx={{margin: "0 16px 12px"}}>
                <TextBtn2 
                    text={DictioneryPanel.dashboardDict.save[props.lang]}
                    disabled={dialogLoading} 
                    loading={dialogLoading}
                    onclick={sendUpdate} 
                    newType={2}
                />
            </DialogActions>
        </>
    )
}


const StyleMulti = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    .title {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
    .row {
        align-items: center;
        display: flex;
        gap: 0.7rem;
        margin-bottom: 0.7rem;
    }
`;

function MultiAdd(props){
    const onChange = (e) => {
        const value = e.target.value;
        const [name, index] = e.target.name.split("-");
        let temp = [...props.value];
        let temp2 = {...temp[index]};
        temp2[name] = value;
        temp[index] = temp2;
        props.onchange({
            target: {
                value: temp,
                name: props.name
            }
        });
    }
    const onChangeNum = (e) => {
        const value = e.target.value;
        const [name, index] = e.target.name.split("-");
        let temp = [...props.value];
        let temp2 = {...temp[index]};
        temp2[name] = "";
        if(isNaN(parseInt(value)) === false){
            temp2[name] = parseInt(value);
        }
        temp[index] = temp2;
        props.onchange({
            target: {
                value: temp,
                name: props.name
            }
        });
    }
    const onChangeAdd = (e) => {
        let temp = [...props.value];
        temp.push({});
        props.onchange({
            target: {
                value: temp,
                name: props.name
            }
        });
    }
    const onChangeDel = (i) => {
        let temp = [...props.value];
        temp.splice(i, 1);
        props.onchange({
            target: {
                value: temp,
                name: props.name
            }
        });
    }
    const copyField = () => {
        let content = JSON.stringify(props.value);
        navigator.clipboard.writeText(content).then(() => {
            // good
        })
    }
    const pasteField = async () => {
        try {
            const clipboardContents = await navigator.clipboard.readText();
            let value = JSON.parse(clipboardContents);
            props.onchange({
                target: {
                    value: value,
                    name: props.name
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    const showFeilds = () => {
        return props.value.map((v, i) => {
            return (
                <div className="row">
                    <TextInputWTitle
                        title={"جواب"}
                        name={"Text-" + i}
                        value={v.Text}
                        onchange={onChange}
                        error={""}
                    />
                    <TextInputWTitle
                        title={"نمره"}
                        name={"number-" + i}
                        value={v.number}
                        onchange={onChangeNum}
                        error={""}
                    />
                    <IconButton
                        aria-label="close"
                        onClick={() => onChangeDel(i)}
                        sx={{
                            marginBottom: "12px",
                            color: "var(--n-primary-8)",
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </div>
            )
        })
    }
    
    return (
        <StyleMulti>
            <div className="title">
                <div>{props.title}</div>
                <IconButton
                    aria-label="copy"
                    onClick={copyField}
                    sx={{
                        color: "var(--n-primary-7)",
                    }}
                    >
                    <ContentCopyRounded />
                </IconButton>
                <IconButton
                    aria-label="paste"
                    onClick={pasteField}
                    sx={{
                        color: "var(--n-primary-7)",
                    }}
                    >
                    <ContentPasteGoRounded />
                </IconButton>
            </div>
            {showFeilds()}
            <div className="add">
            <Button 
                variant="outlined" 
                startIcon={<AddRounded />}
                onClick={onChangeAdd}
            >
            اضافه
            </Button>
            </div>
        </StyleMulti>
    )
}
